module.exports = __webpack_public_path__ + "static/social-media-image-55785e3e685e804ae50b8e2269e6e95a.png";